(() => {
  'use strict';

  const DATA = window.ForeFrontFinderData || {};
  const PRINTERS = Array.isArray(DATA.printers) ? DATA.printers : [];
  const LABELS = Array.isArray(DATA.labels) ? DATA.labels : [];
  const INK = Array.isArray(DATA.ink) ? DATA.ink : [];
  const CORE_PROFILES = [
    { id: 'core-2c4od', brandName: 'Matched by roll specifications', model: '2\" Core / 4\" OD', name: '2\" Core / 4\" OD', profile: '2C4OD', profiles: ['2C4OD'], specOnly: true },
    { id: 'core-3c6od', brandName: 'Matched by roll specifications', model: '3\" Core / 6\" OD', name: '3\" Core / 6\" OD', profile: '3C6OD', profiles: ['3C6OD'], specOnly: true },
    { id: 'core-3c8od', brandName: 'Matched by roll specifications', model: '3\" Core / 8\" OD', name: '3\" Core / 8\" OD', profile: '3C8OD', profiles: ['3C8OD'], specOnly: true }
  ];
  const productCache = new Map();
  const dealEasyProductCache = new Map();
  let dealEasyLabelConfigPromise = null;
  const MATERIAL_ORDER = ['matte-paper', 'gloss-paper', 'matte-bopp', 'gloss-bopp'];
  const SAVED_PRINTER_KEY = 'forefront-finder-saved-printer';
  const QUICK_QUANTITIES = [1, 5, 10, 20, 40];
  const MATERIAL_COPY = {
    'matte-paper': 'Best value for dry indoor use, with a smooth finish that is easy to write on.',
    'gloss-paper': 'Bright glossy paper for vivid product graphics and dry packaging applications.',
    'matte-bopp': 'Durable synthetic film with a premium low-glare finish for demanding applications.',
    'gloss-bopp': 'Water-resistant synthetic film with vibrant shine for bottles, jars and packaging.'
  };
  const SHAPE_COPY = {
    rectangle: ['Rectangles', 'The most popular shape for product and barcode labels.'],
    square: ['Squares', 'Balanced square labels for jars, boxes and containers.'],
    circle: ['Circles', 'Round labels for lids, seals and product branding.'],
    continuous: ['Continuous', 'Cut the roll to the exact length your job needs.'],
    custom: ['Custom Size', 'Ask ForeFront for a custom die or special construction.']
  };

  const escapeHtml = (value) => String(value == null ? '' : value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');

  const imageUrl = (value, width = 600) => {
    if (!value) return '';
    const source = typeof value === 'string' ? value : (value.src || value.url || '');
    if (!source) return '';
    if (source.includes('width=')) return source;
    return `${source}${source.includes('?') ? '&' : '?'}width=${width}`;
  };

  const rootPath = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const productUrl = (handle) => `${rootPath()}products/${encodeURIComponent(handle)}`;
  const productJsonUrl = (handle) => `${productUrl(handle)}.js`;

  const currency = () => (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'CAD';
  const money = (cents) => {
    const amount = Number(cents || 0) / 100;
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-CA', {
        style: 'currency',
        currency: currency(),
        currencyDisplay: 'narrowSymbol'
      }).format(amount);
    } catch (_error) {
      return `C$${amount.toFixed(2)}`;
    }
  };

  const moneyWithCurrency = (cents) => `${money(cents)} ${currency()}`;

  const dealEasyStorefrontContext = () => {
    const shop = String((window.Shopify && window.Shopify.shop) || '').trim();
    const token = String(window.dealeasyPublicAccessToken || '').trim();
    if (!/^[a-z0-9][a-z0-9.-]*\.myshopify\.com$/i.test(shop) || !token) return null;
    return { shop, token };
  };

  const dealEasyGraphQL = async (query, variables = {}) => {
    const context = dealEasyStorefrontContext();
    if (!context) throw new Error('DealEasy storefront pricing is not ready');
    const response = await fetch(`https://${context.shop}/api/2026-07/graphql.json`, {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': context.token
      },
      body: JSON.stringify({ query, variables })
    });
    if (!response.ok) throw new Error('Bulk pricing service unavailable');
    const payload = await response.json();
    if (Array.isArray(payload.errors) && payload.errors.length) throw new Error('Bulk pricing query failed');
    return payload.data || {};
  };

  const getDealEasyLabelConfig = () => {
    if (dealEasyLabelConfigPromise) return dealEasyLabelConfigPromise;
    const query = `
      query ForeFrontLabelDiscounts {
        metaobjects(type: "$app:dealeasy-vds", first: 250) {
          nodes { field(key: "discount") { value } }
        }
      }
    `;
    dealEasyLabelConfigPromise = dealEasyGraphQL(query).then((data) => {
      const nodes = (data.metaobjects && data.metaobjects.nodes) || [];
      const now = Date.now();
      const offers = nodes.map((node) => {
        try { return JSON.parse(node.field && node.field.value); } catch (_error) { return null; }
      }).filter(Boolean);
      const offer = offers.find((item) => {
        const active = String(item.status || '').toUpperCase() === 'ACTIVE';
        const labelOffer = String(item.title || '').trim().toLowerCase() === 'label bulk discount';
        const started = !item.startsAt || Date.parse(item.startsAt) <= now;
        const notEnded = !item.endsAt || Date.parse(item.endsAt) > now;
        return active && labelOffer && started && notEnded;
      });
      if (!offer) return null;
      const configField = (offer.metafields || []).find((field) =>
        field.namespace === 'lb-dealeasy-discount' && field.key === 'lb-dealeasy-config'
      );
      let config = offer;
      if (Array.isArray(offer.metafields)) {
        if (!configField || !configField.value) return null;
        try { config = JSON.parse(configField.value); } catch (_error) { return null; }
      }
      const tiers = (config.tiers || []).map((tier) => ({
        quantity: Math.max(1, Number(tier.quantity) || 1),
        value: Math.max(0, Number(tier.value) || 0)
      })).filter((tier) => tier.value > 0).sort((a, b) => a.quantity - b.quantity);
      if (!tiers.length) return null;
      return {
        title: offer.title,
        type: String(config.type || 'PERCENTAGE').toUpperCase(),
        appliesTo: String(config.appliesTo || 'ALL').toUpperCase(),
        selectedProductIds: config.selectedProductIds || [],
        selectedCollectionIds: config.selectedCollectionIds || [],
        enableExclusion: Boolean(config.enableExclusion),
        exclusionType: String(config.exclusionType || '').toUpperCase(),
        excludedProductIds: config.excludedProductIds || [],
        excludedCollectionIds: config.excludedCollectionIds || [],
        tiers
      };
    }).catch(() => null);
    return dealEasyLabelConfigPromise;
  };

  const getDealEasyProductContext = (handle) => {
    if (dealEasyProductCache.has(handle)) return dealEasyProductCache.get(handle);
    const query = `
      query ForeFrontLabelProduct($handle: String!) {
        product(handle: $handle) {
          id
          collections(first: 100) { nodes { id } }
        }
      }
    `;
    const promise = dealEasyGraphQL(query, { handle }).then((data) => {
      if (!data.product) return null;
      return {
        id: data.product.id,
        collectionIds: ((data.product.collections && data.product.collections.nodes) || []).map((item) => item.id)
      };
    }).catch(() => null);
    dealEasyProductCache.set(handle, promise);
    return promise;
  };

  const isDealEasyEligible = (config, productContext) => {
    if (!config || !productContext) return false;
    const productId = productContext.id;
    const collectionIds = productContext.collectionIds || [];
    if (config.enableExclusion && config.exclusionType === 'PRODUCTS' && config.excludedProductIds.includes(productId)) return false;
    if (config.enableExclusion && config.exclusionType === 'COLLECTIONS' && collectionIds.some((id) => config.excludedCollectionIds.includes(id))) return false;
    if (config.appliesTo === 'PRODUCTS') return config.selectedProductIds.includes(productId);
    if (config.appliesTo === 'COLLECTIONS') return collectionIds.some((id) => config.selectedCollectionIds.includes(id));
    return true;
  };

  const tierUnitPrice = (basePrice, tier, config) => {
    if (!tier || !tier.value) return Number(basePrice || 0);
    if (config && config.type === 'FIXED_AMOUNT') return Math.max(0, Number(basePrice || 0) - Math.round(tier.value * 100));
    const cents = Number(basePrice || 0);
    return Math.max(0, cents - Math.floor(cents * tier.value / 100));
  };

  const pricingRows = (basePrice, config) => {
    const tiers = config && Array.isArray(config.tiers) ? config.tiers : [];
    const startsAtOne = tiers.length && tiers[0].quantity === 1;
    const rows = startsAtOne ? [] : [{ quantity: 1, value: 0 }];
    tiers.forEach((tier) => rows.push({ ...tier }));
    return rows.map((tier, index) => ({
      ...tier,
      maxQuantity: rows[index + 1] ? rows[index + 1].quantity - 1 : null,
      unitPrice: tierUnitPrice(basePrice, tier, config)
    }));
  };

  const activePricingRow = (rows, quantity) => [...rows].reverse().find((row) => quantity >= row.quantity) || rows[0] || null;

  const debounce = (fn, delay = 180) => {
    let timer;
    return (...args) => {
      window.clearTimeout(timer);
      timer = window.setTimeout(() => fn(...args), delay);
    };
  };

  const shapeKey = (label) => {
    const raw = String(label.shape || '').toLowerCase();
    if (raw.includes('continuous')) return 'continuous';
    if (raw === 'circle' || raw === 'round' || raw.includes('circular')) return 'circle';
    if (raw.includes('square')) return 'square';
    if (Number(label.width) && Number(label.length) && Math.abs(Number(label.width) - Number(label.length)) < 0.001) return 'square';
    return 'rectangle';
  };

  const printerLabels = (printer) => LABELS.filter((label) => printer && printer.specOnly
    ? label.profile === printer.profile
    : Array.isArray(label.printers) && label.printers.includes(printer.id)
  );

  const printerInk = (printer) => INK.filter((item) =>
    Array.isArray(item.printers) && item.printers.includes(printer.id)
  );

  const unique = (items) => [...new Set(items)];

  const cleanDimension = (value) => {
    const number = Number(value);
    if (!Number.isFinite(number) || number <= 0) return null;
    return Math.round(number * 1000) / 1000;
  };

  const formatDimension = (value) => {
    const number = Number(value);
    if (!Number.isFinite(number)) return '';
    return Number(number.toFixed(3)).toString();
  };

  const readableDimensionDifference = (difference, axis) => {
    if (Math.abs(difference) < 0.001) return `Same ${axis}`;
    const amount = `${formatDimension(Math.abs(difference))}\"`;
    if (axis === 'width') return `${amount} ${difference > 0 ? 'wider' : 'narrower'}`;
    return `${amount} ${difference > 0 ? 'longer' : 'shorter'}`;
  };

  const getLiveProduct = async (handle) => {
    if (productCache.has(handle)) return productCache.get(handle);
    const promise = fetch(productJsonUrl(handle), {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    }).then((response) => {
      if (!response.ok) throw new Error('Live product unavailable');
      return response.json();
    }).catch((error) => {
      productCache.delete(handle);
      throw error;
    });
    productCache.set(handle, promise);
    return promise;
  };

  const findVariant = (liveProduct, sku) => {
    const variants = Array.isArray(liveProduct && liveProduct.variants) ? liveProduct.variants : [];
    if (sku) {
      const exact = variants.find((variant) => String(variant.sku || '').trim().toLowerCase() === String(sku).trim().toLowerCase());
      if (exact) return exact;
    }
    return variants.length === 1 ? variants[0] : null;
  };

  class ForeFrontFinder {
    constructor(root) {
      this.root = root;
      this.app = root.querySelector('[data-ffsf-app]');
      this.status = root.querySelector('[data-ffsf-status]');
      this.progress = [...root.querySelectorAll('[data-ffsf-progress]')];
      this.historyBackButton = root.querySelector('[data-ffsf-history-back]');
      this.historyForwardButton = root.querySelector('[data-ffsf-history-forward]');
      this.savePrinterButton = root.querySelector('[data-ffsf-save-printer]');
      this.renderToken = 0;
      this.toastTimer = null;
      this.savedPrinterId = this.loadSavedPrinter();
      this.state = {
        screen: 'printers',
        query: '',
        brand: 'all',
        printerGroup: 'current',
        printerId: null,
        supply: null,
        shape: null,
        size: null,
        material: null,
        labelHandle: null,
        quantity: 1,
        saleOnly: false,
        dealMode: false,
        inkCategory: 'all',
        inkVariants: {},
        restockIntent: false,
        restockInkHandle: null,
        restockInkSku: null,
        requestedWidth: '',
        requestedLength: ''
      };
      this.restoreFromUrl();
      this.trail = [this.snapshotState()];
      this.trailIndex = 0;
      this.handlePrinterSearch = debounce((value) => this.updatePrinterSearch(value), 150);
      this.bind();
      this.render();
    }

    get printer() {
      return [...PRINTERS, ...CORE_PROFILES].find((printer) => printer.id === this.state.printerId) || null;
    }

    bind() {
      this.root.addEventListener('click', (event) => this.onClick(event));
      this.root.addEventListener('change', (event) => this.onChange(event));
      this.root.addEventListener('keydown', (event) => {
        if (event.target.matches('[data-ffsf-hero-search]') && event.key === 'Enter') {
          event.preventDefault();
          const button = this.root.querySelector('[data-action="hero-match"]');
          if (button) button.click();
        }
      });
      this.root.addEventListener('input', (event) => {
        if (event.target.matches('[data-ffsf-printer-search]')) this.handlePrinterSearch(event.target.value);
        else this.onInput(event);
      });
      this.root.querySelectorAll('[data-ffsf-scroll-to-tool]').forEach((scrollButton) => {
        scrollButton.addEventListener('click', () => {
          this.root.querySelector('.ffsf-tool-wrap').scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      });
      window.addEventListener('popstate', () => {
        this.resetState();
        this.restoreFromUrl();
        const serialized = JSON.stringify(this.snapshotState());
        const trailIndex = this.trail.findIndex((item) => JSON.stringify(item) === serialized);
        if (trailIndex >= 0) this.trailIndex = trailIndex;
        else this.recordTrail();
        this.render();
      });
    }

    resetState() {
      Object.assign(this.state, {
        screen: 'printers', query: '', brand: 'all', printerGroup: 'current',
        printerId: null, supply: null, shape: null, size: null,
        material: null, labelHandle: null, quantity: 1, saleOnly: false, dealMode: false,
        inkCategory: 'all', inkVariants: {}, restockIntent: false,
        restockInkHandle: null, restockInkSku: null,
        requestedWidth: '', requestedLength: ''
      });
    }

    loadSavedPrinter() {
      try {
        const printerId = window.localStorage.getItem(SAVED_PRINTER_KEY);
        return PRINTERS.some((printer) => printer.id === printerId) ? printerId : null;
      } catch (_error) {
        return null;
      }
    }

    snapshotState() {
      return JSON.parse(JSON.stringify(this.state));
    }

    recordTrail() {
      const snapshot = this.snapshotState();
      const current = this.trail && this.trail[this.trailIndex];
      if (current && JSON.stringify(current) === JSON.stringify(snapshot)) return;
      this.trail = (this.trail || []).slice(0, this.trailIndex + 1);
      this.trail.push(snapshot);
      this.trailIndex = this.trail.length - 1;
    }

    replaceTrail() {
      if (!this.trail || !this.trail.length) {
        this.trail = [this.snapshotState()];
        this.trailIndex = 0;
        return;
      }
      this.trail[this.trailIndex] = this.snapshotState();
    }

    restoreTrail(index) {
      if (index < 0 || index >= this.trail.length) return;
      this.trailIndex = index;
      this.state = JSON.parse(JSON.stringify(this.trail[index]));
      this.updateUrl(false);
      this.render();
      this.focusScreen();
    }

    track(eventName, detail = {}) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: eventName, finder: 'label_ink_finder', ...detail });
    }

    restoreFromUrl() {
      const params = new URLSearchParams(window.location.search);
      const printerId = params.get('printer');
      const printer = [...PRINTERS, ...CORE_PROFILES].find((item) => item.id === printerId);
      if (!printer) return;
      this.state.printerId = printer.id;
      this.state.supply = params.get('supply');
      this.state.shape = params.get('shape');
      this.state.size = params.get('size');
      if (this.state.size && this.state.shape) {
        const restoredLabel = printerLabels(printer).find((label) => shapeKey(label) === this.state.shape && label.size === this.state.size);
        this.state.requestedWidth = restoredLabel && restoredLabel.width != null ? String(restoredLabel.width) : '';
        this.state.requestedLength = restoredLabel && restoredLabel.length != null ? String(restoredLabel.length) : '';
      }
      this.state.material = params.get('material');
      this.state.labelHandle = params.get('product');
      this.state.dealMode = params.get('deals') === '1';
      this.state.saleOnly = this.state.dealMode && printerLabels(printer).some((label) => label.sale);
      if (this.state.supply === 'ink') this.state.screen = 'ink';
      else if (this.state.supply === 'restock') this.state.screen = this.state.material ? 'order' : 'labels';
      else if (this.state.material) this.state.screen = 'order';
      else if (this.state.size) this.state.screen = 'materials';
      else if (this.state.supply === 'labels') this.state.screen = 'labels';
      else this.state.screen = 'supplies';
    }

    updateUrl(push = true) {
      const url = new URL(window.location.href);
      ['printer', 'supply', 'shape', 'size', 'material', 'product', 'deals'].forEach((key) => url.searchParams.delete(key));
      if (this.state.printerId) url.searchParams.set('printer', this.state.printerId);
      if (this.state.supply) url.searchParams.set('supply', this.state.supply);
      if (this.state.shape) url.searchParams.set('shape', this.state.shape);
      if (this.state.size) url.searchParams.set('size', this.state.size);
      if (this.state.material) url.searchParams.set('material', this.state.material);
      if (this.state.labelHandle) url.searchParams.set('product', this.state.labelHandle);
      if (this.state.dealMode) url.searchParams.set('deals', '1');
      window.history[push ? 'pushState' : 'replaceState']({ ffsf: true }, '', url);
    }

    announce(message) {
      if (!this.status) return;
      this.status.textContent = '';
      window.setTimeout(() => { this.status.textContent = message; }, 20);
    }

    setScreen(screen, push = true) {
      this.state.screen = screen;
      this.updateUrl(push);
      if (push) this.recordTrail();
      else this.replaceTrail();
      this.render();
      this.focusScreen();
      this.root.querySelector('.ffsf-tool-wrap').scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    focusScreen() {
      const heading = this.app.querySelector('h2');
      if (heading) {
        heading.setAttribute('tabindex', '-1');
        heading.focus({ preventScroll: true });
      }
    }

    setProgress() {
      const step = this.state.screen === 'printers' ? 1 : (this.state.screen === 'supplies' ? 2 : 3);
      this.progress.forEach((item, index) => {
        const number = index + 1;
        item.classList.toggle('is-active', number === step);
        item.classList.toggle('is-complete', number < step);
        item.disabled = number === 2 ? !this.state.printerId : (number === 3 ? !this.state.supply : false);
        if (number === step) item.setAttribute('aria-current', 'step');
        else item.removeAttribute('aria-current');
      });
    }

    updateNavigation() {
      if (this.historyBackButton) this.historyBackButton.disabled = this.trailIndex <= 0;
      if (this.historyForwardButton) this.historyForwardButton.disabled = this.trailIndex >= this.trail.length - 1;
      if (this.savePrinterButton) {
        this.savePrinterButton.disabled = !this.printer;
        this.savePrinterButton.textContent = this.printer && this.savedPrinterId === this.printer.id ? 'Printer saved ✓' : 'Save my printer';
      }
    }

    render() {
      this.renderToken += 1;
      this.setProgress();
      this.updateNavigation();
      if (!PRINTERS.length) {
        this.app.innerHTML = '<div class="ffsf-empty"><strong>The finder data could not load.</strong>Please refresh the page or contact ForeFront for help.</div>';
        return;
      }
      const screens = {
        printers: () => this.renderPrinters(),
        supplies: () => this.renderSupplies(),
        labels: () => this.renderLabelBuilder(),
        materials: () => this.renderMaterials(),
        order: () => this.renderOrder(),
        ink: () => this.renderInk(),
        restock: () => this.renderRestock()
      };
      (screens[this.state.screen] || screens.printers)();
    }

    renderPrinters() {
      const query = this.state.query.trim().toLowerCase();
      const searching = Boolean(query);
      const eraPool = PRINTERS.filter((printer) => {
        const searchText = [printer.name, printer.model, printer.brandName, ...(printer.aliases || [])].join(' ').toLowerCase();
        return searching ? searchText.includes(query) : true;
      });
      const visiblePrinters = eraPool.filter((printer) => this.state.brand === 'all' || printer.brand === this.state.brand);
      const brands = unique(PRINTERS.map((printer) => printer.brand)).map((id) => ({
        id,
        name: (PRINTERS.find((printer) => printer.brand === id) || {}).brandName || id,
        count: eraPool.filter((printer) => printer.brand === id).length
      }));
      const savedPrinter = PRINTERS.find((printer) => printer.id === this.savedPrinterId);
      const savedPrinterCallout = savedPrinter && !query ? `<div class="ffsf-saved-printer"><span><small>SAVED PRINTER</small><strong>${escapeHtml(savedPrinter.name)}</strong></span><button type="button" data-action="use-saved-printer" data-printer="${escapeHtml(savedPrinter.id)}">Use saved printer</button></div>` : '';
      const dealCallout = this.state.dealMode ? '<div class="ffsf-deal-intent"><strong>Compatibility-safe deal mode is on</strong><span>Choose your printer and we will show only sale labels that fit it.</span></div>' : '';

      this.app.innerHTML = `
        <div class="ffsf-screen-heading">
          <p class="ffsf-eyebrow">${this.state.dealMode ? 'MATCH MY 30%-OFF LABELS' : 'ONE PRINTER, EVERY SAFE SUPPLY PATH'}</p>
          <h2>Choose your supported printer</h2>
          <p>Search the model number or choose a brand. Every supported printer is treated equally.</p>
        </div>
        ${dealCallout}
        ${savedPrinterCallout}
        <div class="ffsf-search">
          <label class="visually-hidden" for="ffsf-printer-search-${escapeHtml(this.root.dataset.sectionId)}">Search printer models</label>
          <input id="ffsf-printer-search-${escapeHtml(this.root.dataset.sectionId)}" type="search" value="${escapeHtml(this.state.query)}" placeholder="Try CW-C4000, TM-C3500, LX910 or VP700" data-ffsf-printer-search autocomplete="off">
          ${this.state.query ? '<button type="button" data-action="clear-search" aria-label="Clear printer search">×</button>' : ''}
        </div>
        <div class="ffsf-filter-toolbar">
          <strong>${visiblePrinters.length} supported model${visiblePrinters.length === 1 ? '' : 's'}</strong>
          <div class="ffsf-brand-filters" aria-label="Filter printers by brand">
            <button type="button" class="ffsf-brand-filter ${this.state.brand === 'all' ? 'is-active' : ''}" data-action="filter-brand" data-brand="all" aria-pressed="${this.state.brand === 'all'}">All <span>(${eraPool.length})</span></button>
            ${brands.map((brand) => `<button type="button" class="ffsf-brand-filter ${this.state.brand === brand.id ? 'is-active' : ''}" data-action="filter-brand" data-brand="${escapeHtml(brand.id)}" aria-pressed="${this.state.brand === brand.id}" ${brand.count ? '' : 'disabled'}>${escapeHtml(brand.name.replace(' ColorWorks', ''))} <span>(${brand.count})</span></button>`).join('')}
          </div>
        </div>
        ${visiblePrinters.length ? this.printerGroup(
          searching ? 'Matching printer models' : 'All supported printer models',
          'Choose your exact model to see compatible labels and available ink supplies.',
          visiblePrinters,
          false
        ) : ''}
        <section class="ffsf-core-shop"><div><span class="ffsf-kicker">PRINTER NOT LISTED?</span><h3>Shop labels by core and roll size</h3><p>Choose the specifications shown on your current roll or printer manual.</p></div><div class="ffsf-core-shop__grid">${CORE_PROFILES.map((profile) => `<button type="button" data-action="select-core-profile" data-profile="${escapeHtml(profile.id)}"><span class="ffsf-core-ring" aria-hidden="true"></span><strong>${escapeHtml(profile.name)}</strong><small>Shop compatible rolls →</small></button>`).join('')}</div><small class="ffsf-core-shop__note">Not sure? Ask ForeFront to verify your printer before ordering.</small></section>
        ${!visiblePrinters.length ? `<div class="ffsf-empty"><strong>${searching ? 'No exact model found.' : 'No models in this brand and group.'}</strong>${searching ? 'Try only the model number, or ask ForeFront to confirm compatibility.' : 'Choose another brand or switch printer groups.'}</div>` : ''}
      `;
    }

    printerGroup(title, copy, printers, legacy) {
      return `
        <section class="ffsf-printer-group ${legacy ? 'ffsf-printer-group--legacy' : ''}">
          ${title ? `<div class="ffsf-group-heading"><div><h3>${escapeHtml(title)}</h3><p>${escapeHtml(copy)}</p></div></div>` : ''}
          <div class="ffsf-printer-grid">
            ${printers.map((printer) => this.printerCard(printer)).join('')}
          </div>
        </section>
      `;
    }

    printerCard(printer) {
      const labels = Number(printer.labelCount || printerLabels(printer).length || 0);
      const inks = this.groupedInk(printer).length;
      const profileText = (printer.profiles || [printer.profile]).filter(Boolean).map((profile) => profile.replace('C', '" Core / ').replace('OD', '" OD')).join(' + ');
      return `
        <article class="ffsf-printer-card">
          <span class="ffsf-badge ffsf-badge--new">${inks ? 'LABELS + INK' : 'LABELS'}</span>
          <button type="button" class="ffsf-printer-card__select" data-action="select-printer" data-printer="${escapeHtml(printer.id)}" aria-label="Choose ${escapeHtml(printer.name)}">
            <span class="ffsf-printer-card__image"><img src="${escapeHtml(imageUrl(printer.image, 420))}" width="420" height="320" loading="lazy" decoding="async" alt="${escapeHtml(printer.name)}"></span>
            <span class="ffsf-printer-card__brand">${escapeHtml(printer.brandName)}</span>
            <h4>${escapeHtml(printer.model)}</h4>
            <span class="ffsf-printer-card__specs">${profileText ? `<span>${escapeHtml(profileText)}</span>` : ''}</span>
            <span class="ffsf-printer-card__availability">${labels ? `${labels} label choices` : 'Printer collection'}${inks ? ` · ${inks} ink choices` : ''}</span>
          </button>
          <a class="ffsf-printer-card__link" href="${escapeHtml(printer.url || '/collections/inkjet-labels')}">Browse ${escapeHtml(printer.model)} collection</a>
        </article>
      `;
    }

    renderSupplies() {
      const printer = this.printer;
      if (!printer) return this.setScreen('printers', false);
      const labels = printerLabels(printer);
      const inks = this.groupedInk(printer);
      const saleCount = labels.filter((label) => label.sale).length;
      const restockProduct = labels.length ? this.restockInkProduct(printer) : null;
      const collectionOnly = printer.labelMode === 'collection-only' && !labels.length;
      const labelsCard = collectionOnly ? `
        <a class="ffsf-supply-card" href="${escapeHtml(printer.url || '/collections/inkjet-labels')}">
          <span class="ffsf-supply-card__image"><img src="${escapeHtml(imageUrl(printer.image, 520))}" width="520" height="420" loading="lazy" alt="${escapeHtml(printer.name)} labels"></span>
          <span><span class="ffsf-kicker">LABEL COLLECTION</span><h3>Browse compatible label rolls</h3><p>This newer model has a printer collection, but the export does not yet contain exact product compatibility tags. Open the collection to shop safely.</p><span class="ffsf-card-link">Open ${escapeHtml(printer.model)} labels →</span></span>
        </a>` : `
        <button type="button" class="ffsf-supply-card" data-action="pick-supply" data-supply="labels" ${labels.length ? '' : 'disabled'}>
          <span class="ffsf-supply-card__image"><img src="${escapeHtml(imageUrl((labels[0] || {}).image, 520))}" width="520" height="420" loading="lazy" alt="ForeFront compatible inkjet label roll"></span>
          <span><span class="ffsf-kicker">${labels.length} EXACT PRODUCT MATCHES</span><h3>Blank Inkjet Label Rolls</h3><p>Choose the shape, size and material, then view the exact product and live Shopify price.</p>${saleCount ? `<span class="ffsf-card-link"><span class="ffsf-sale-pill">${saleCount} sale label${saleCount === 1 ? '' : 's'} available</span></span>` : '<span class="ffsf-card-link">Find my label →</span>'}</span>
        </button>`;
      const bundledInkImage = restockProduct ? restockProduct.image : inks[0] && inks[0].image;
      const inkCard = inks.length ? `
        <button type="button" class="ffsf-supply-card" data-action="pick-supply" data-supply="ink">
          <span class="ffsf-supply-card__image"><img src="${escapeHtml(imageUrl(bundledInkImage, 520))}" width="520" height="420" loading="lazy" alt="Bundled ${escapeHtml(printer.brandName)} printer ink"></span>
          <span><span class="ffsf-kicker">${inks.length} VERIFIED SUPPLY CHOICES</span><h3>Ink &amp; Maintenance Supplies</h3><p>Shop exact cartridges, multipacks, maintenance boxes and accessories for this printer.</p><span class="ffsf-card-link">${inks.length} exact ink choice${inks.length === 1 ? '' : 's'} →</span></span>
        </button>` : '';
      const restockCard = restockProduct ? `
        <button type="button" class="ffsf-supply-card ffsf-supply-card--restock" data-action="pick-supply" data-supply="restock">
          <span class="ffsf-supply-card__image"><img src="${escapeHtml(imageUrl(restockProduct.image, 520))}" width="520" height="420" loading="lazy" alt="Compatible label and ink restock supplies for ${escapeHtml(printer.name)}"></span>
          <span><span class="ffsf-kicker">TIME-SAVING BUYING PATH</span><h3>Labels + Ink Restock</h3><p>Pair compatible label rolls with a verified ink multipack or restock kit in one guided review.</p><span class="ffsf-card-link">Build a compatible restock →</span></span>
        </button>` : '';
      const dealBanner = this.state.dealMode
        ? (saleCount
          ? `<div class="ffsf-deal-banner"><span><strong>${saleCount} compatible 30%-off label matches</strong><small>Deal mode stays locked to ${escapeHtml(printer.model)} compatibility.</small></span><b>DEAL MODE ON</b></div>`
          : '<div class="ffsf-deal-banner is-honest"><span><strong>No 30%-off label match for this printer right now</strong><small>You can still use live quantity pricing and shop compatible products only.</small></span><b>EXACT MATCH</b></div>')
        : (saleCount ? `<div class="ffsf-deal-banner"><span><strong>${saleCount} compatible sale label${saleCount === 1 ? '' : 's'} available</strong><small>We will never send you to an incompatible deal.</small></span><button type="button" data-action="activate-deals">Show my sale matches</button></div>` : '');

      this.app.innerHTML = `
        ${this.selectedPrinterBar(printer)}
        <div class="ffsf-screen-heading"><p class="ffsf-eyebrow">CHOOSE WHAT YOU NEED</p><h2>Supplies for ${escapeHtml(printer.name)}</h2><p>Your printer selection now controls both the label and ink results.</p></div>
        ${dealBanner}
        <div class="ffsf-supply-grid ${restockCard ? 'has-three' : (inkCard ? '' : 'is-labels-only')}">${labelsCard}${inkCard}${restockCard}</div>
        ${!inks.length ? '<div class="ffsf-info-note">This brand follows the labels-only path. Exact ink matching is currently available for Epson and Primera printers.</div>' : ''}
      `;
    }

    selectedPrinterBar(printer, backAction = 'back-printers') {
      return `<div class="ffsf-selected-bar"><div><small>SELECTED PRINTER</small><strong>${escapeHtml(printer.name)} · ${escapeHtml((printer.profiles || [printer.profile]).filter(Boolean).join(' + '))}</strong></div><button type="button" class="ffsf-link-button" data-action="${escapeHtml(backAction)}">Change printer</button></div>`;
    }

    renderLabelBuilder() {
      const printer = this.printer;
      if (!printer) return this.setScreen('printers', false);
      const allLabels = printerLabels(printer);
      const saleCount = allLabels.filter((label) => label.sale).length;
      let labels = allLabels;
      if (this.state.saleOnly) labels = labels.filter((label) => label.sale);
      const availableShapes = unique(labels.map(shapeKey));
      const shapeLabels = this.state.shape ? labels.filter((label) => shapeKey(label) === this.state.shape) : [];
      const allShapeLabels = this.state.shape ? allLabels.filter((label) => shapeKey(label) === this.state.shape) : [];
      const sizes = [...new Map(shapeLabels.map((label) => [label.size, label])).values()].sort((a, b) => (Number(a.width) - Number(b.width)) || (Number(a.length) - Number(b.length)));

      this.app.innerHTML = `
        ${this.builderToolbar(printer, 'Choose label shape and size', 'back-supplies')}
        ${this.labelProgress(1)}
        <div class="ffsf-builder-heading"><p class="ffsf-eyebrow">LABEL BUILDER</p><h2>Choose your label shape</h2><p>Only sizes with an exact compatible ForeFront product are shown.</p></div>
        ${this.state.dealMode && !saleCount ? '<div class="ffsf-deal-banner is-honest"><span><strong>No 30%-off label match for this printer right now</strong><small>All compatible regular-price labels and live volume savings are still available.</small></span><b>EXACT MATCH</b></div>' : ''}
        <div class="ffsf-filter-toolbar"><strong>${labels.length} compatible label products</strong><div class="ffsf-brand-filters">${saleCount ? `<button type="button" class="ffsf-chip ${this.state.saleOnly ? 'is-active' : ''}" data-action="toggle-sale" aria-pressed="${this.state.saleOnly}">${this.state.saleOnly ? `Showing ${saleCount} sale labels` : `Show ${saleCount} sale labels only`}</button>` : '<span class="ffsf-chip is-disabled">No sale match today</span>'}</div></div>
        <div class="ffsf-shape-grid">
          ${availableShapes.map((shape) => this.shapeCard(shape)).join('')}
          ${this.shapeCard('custom')}
        </div>
        ${this.state.shape && this.state.shape !== 'custom' ? `
          <div class="ffsf-size-workspace">
          <section class="ffsf-size-panel">
            <div class="ffsf-size-toolbar"><h3>Select your label size</h3><label class="visually-hidden" for="ffsf-size-search-${escapeHtml(this.root.dataset.sectionId)}">Filter compatible label sizes</label><input id="ffsf-size-search-${escapeHtml(this.root.dataset.sectionId)}" type="search" placeholder="Filter sizes, for example 4 x 2" data-ffsf-size-search></div>
            <div class="ffsf-size-grid" data-ffsf-size-grid>${sizes.map((label) => this.sizeCard(label, shapeLabels)).join('')}</div>
            ${this.sizeAssistPanel(allShapeLabels)}
          </section>
          ${this.liveRollPreview()}
          </div>` : ''}
        ${this.state.saleOnly && !labels.length ? '<div class="ffsf-empty"><strong>No sale labels for this printer right now.</strong>Turn off the sale-only filter to see all compatible products.</div>' : ''}
      `;
    }

    builderToolbar(printer, title, backAction) {
      return `<div class="ffsf-builder-toolbar"><div class="ffsf-builder-toolbar__printer"><img src="${escapeHtml(imageUrl(printer.image, 130))}" width="130" height="100" alt=""><div><small>${escapeHtml(printer.brandName)}</small><strong>${escapeHtml(printer.model)}</strong></div></div><div><small>CURRENT STEP</small><strong>${escapeHtml(title)}</strong></div><button type="button" class="ffsf-back-button" data-action="${escapeHtml(backAction)}">Back</button></div>`;
    }

    labelProgress(active) {
      const labels = ['Shape & Size', 'Material', 'Quantity & Cart'];
      return `<nav class="ffsf-label-progress" aria-label="Label order steps">${labels.map((label, index) => {
        const step = index + 1;
        const complete = step < active;
        const enabled = step <= active;
        return `<button type="button" class="${step === active ? 'is-active' : (complete ? 'is-complete' : '')}" data-action="go-label-step" data-label-step="${step}" ${enabled ? '' : 'disabled'}><b>${complete ? '✓' : step}</b><span>${label}</span></button>`;
      }).join('')}</nav>`;
    }

    liveRollPreview() {
      const width = cleanDimension(this.state.requestedWidth);
      const length = cleanDimension(this.state.requestedLength);
      const isContinuous = this.state.shape === 'continuous';
      const labelText = this.state.size || (width ? `${formatDimension(width)}\" × ${length ? `${formatDimension(length)}\"` : '?'}` : 'Choose or type a size');
      const feedText = isContinuous && width ? 'Continuous' : (length ? `${formatDimension(length)}\"` : '-');
      const ratio = width && length ? Math.max(.55, Math.min(2, width / length)) : 1.35;
      const rollImage = (printerLabels(this.printer)[0] || {}).image || '';
      return `<aside class="ffsf-live-preview" data-ffsf-live-preview><div class="ffsf-live-preview__heading"><span><small>LIVE ROLL PREVIEW</small><strong data-live-preview-title>${escapeHtml(labelText)}</strong></span><b>✓ Roll format matched</b></div><div class="ffsf-live-preview__visual"><img src="${escapeHtml(imageUrl(rollImage, 620))}" width="620" height="480" alt="Blank inkjet label roll"><span class="ffsf-live-preview__swatch" data-live-preview-swatch style="aspect-ratio:${ratio}/1"><strong data-live-preview-size>${escapeHtml(labelText)}</strong><small>${width ? 'Selected stocked size' : 'Updates as you type'}</small></span><i>${escapeHtml((this.printer.profiles || [this.printer.profile]).join(' + '))}</i></div><div class="ffsf-live-preview__facts"><span><small>WIDTH</small><strong data-live-preview-width>${width ? `${formatDimension(width)}\"` : '-'}</strong></span><span><small>FEED LENGTH</small><strong data-live-preview-length>${escapeHtml(feedText)}</strong></span><span><small>ROLL FORMAT</small><strong>${escapeHtml(this.printer.profile || '')}</strong></span></div></aside>`;
    }

    shapeCard(shape) {
      const copy = SHAPE_COPY[shape] || SHAPE_COPY.rectangle;
      return `<button type="button" class="ffsf-shape-card ${this.state.shape === shape ? 'is-active' : ''}" data-action="select-shape" data-shape="${escapeHtml(shape)}" aria-pressed="${this.state.shape === shape}"><span class="ffsf-shape-icon" aria-hidden="true"></span><strong>${escapeHtml(copy[0])}</strong><span class="visually-hidden">. ${escapeHtml(copy[1])}</span></button>`;
    }

    sizeCard(label, shapeLabels) {
      const hasSale = shapeLabels.some((item) => item.size === label.size && item.sale);
      const active = this.state.size === label.size;
      return `<button type="button" class="ffsf-size-card ${active ? 'is-active' : ''}" data-action="select-size" data-size="${escapeHtml(label.size)}" data-size-text="${escapeHtml(label.size.toLowerCase())}" aria-pressed="${active}">${escapeHtml(label.size)}${hasSale ? '<span class="ffsf-sale-dot">SALE</span>' : ''}</button>`;
    }

    sizeAssistPanel(shapeLabels) {
      return `<details class="ffsf-size-assist">
        <summary><span><strong>Can’t see your size?</strong><small>Enter your finished dimensions and we’ll check the closest compatible ForeFront size.</small></span><b aria-hidden="true">+</b></summary>
        <div class="ffsf-size-assist__body">
          <div class="ffsf-size-assist__intro"><strong>Find a close stocked fit</strong><p>Width stays width and length stays length. We never silently rotate your dimensions.</p></div>
          <div class="ffsf-size-assist__fields">
            <label for="ffsf-request-width-${escapeHtml(this.root.dataset.sectionId)}"><span>Width (inches)</span><input id="ffsf-request-width-${escapeHtml(this.root.dataset.sectionId)}" type="number" min="0.1" max="48" step="0.01" inputmode="decimal" placeholder="3.5" value="${escapeHtml(this.state.requestedWidth)}" data-ffsf-size-assist-input data-dimension="width"></label>
            <label for="ffsf-request-length-${escapeHtml(this.root.dataset.sectionId)}"><span>Length (inches)</span><input id="ffsf-request-length-${escapeHtml(this.root.dataset.sectionId)}" type="number" min="0.1" max="48" step="0.01" inputmode="decimal" placeholder="2.5" value="${escapeHtml(this.state.requestedLength)}" data-ffsf-size-assist-input data-dimension="length"></label>
          </div>
          <div class="ffsf-size-assist__result" data-ffsf-size-assist-result>${this.renderSizeAssistResult(shapeLabels)}</div>
        </div>
      </details>`;
    }

    nearestSizeMatch(shapeLabels) {
      const requestedWidth = cleanDimension(this.state.requestedWidth);
      const requestedLength = cleanDimension(this.state.requestedLength);
      if (requestedWidth == null || requestedLength == null) return { requestedWidth, requestedLength, match: null, complete: false };

      const candidates = [...new Map(shapeLabels.map((label) => [label.size, label])).values()].map((label) => {
        const candidateWidth = cleanDimension(label.width);
        const candidateLength = cleanDimension(label.length) == null && shapeKey(label) === 'continuous' ? requestedLength : cleanDimension(label.length);
        if (candidateWidth == null || candidateLength == null) return null;
        const widthDifference = candidateWidth - requestedWidth;
        const lengthDifference = candidateLength - requestedLength;
        const absoluteWidthDifference = Math.abs(widthDifference);
        const absoluteLengthDifference = Math.abs(lengthDifference);
        const identicalDimensions = Number(absoluteWidthDifference < 0.001) + Number(absoluteLengthDifference < 0.001);
        const closeEnough = absoluteWidthDifference <= Math.max(.5, requestedWidth * .25)
          && absoluteLengthDifference <= Math.max(.5, requestedLength * .25);
        return {
          label,
          candidateWidth,
          candidateLength,
          widthDifference,
          lengthDifference,
          absoluteWidthDifference,
          absoluteLengthDifference,
          identicalDimensions,
          closeEnough,
          normalizedDistance: (absoluteWidthDifference / requestedWidth) + (absoluteLengthDifference / requestedLength),
          areaDifference: Math.abs((candidateWidth * candidateLength) - (requestedWidth * requestedLength))
        };
      }).filter(Boolean).filter((candidate) => candidate.closeEnough).sort((a, b) => (
        (b.identicalDimensions - a.identicalDimensions)
        || (a.normalizedDistance - b.normalizedDistance)
        || (a.areaDifference - b.areaDifference)
        || (a.absoluteWidthDifference - b.absoluteWidthDifference)
        || (a.absoluteLengthDifference - b.absoluteLengthDifference)
      ));

      return { requestedWidth, requestedLength, match: candidates[0] || null, complete: true };
    }

    customQuoteUrl(width = null, length = null) {
      const requestUrl = this.root.dataset.customRequestUrl || '/pages/label-request';
      const params = new URLSearchParams({
        printer: this.printer ? this.printer.name : '',
        request: 'custom-label',
        shape: this.state.shape || ''
      });
      if (cleanDimension(width) != null) params.set('width', formatDimension(width));
      if (cleanDimension(length) != null) params.set('length', formatDimension(length));
      return `${requestUrl}${requestUrl.includes('?') ? '&' : '?'}${params.toString()}`;
    }

    renderSizeAssistResult(shapeLabels) {
      const result = this.nearestSizeMatch(shapeLabels);
      const quoteUrl = this.customQuoteUrl(result.requestedWidth, result.requestedLength);
      if (!result.complete) {
        return `<div class="ffsf-size-assist__prompt"><strong>Enter both dimensions to compare.</strong><p>We only recommend the same label shape and products already verified for ${escapeHtml(this.printer ? this.printer.model : 'your printer')}.</p><a href="${escapeHtml(quoteUrl)}">Request an exact custom size</a></div>`;
      }
      if (!result.match) {
        return `<div class="ffsf-size-assist__no-match"><span class="ffsf-size-assist__status">EXACT-SIZE QUOTE RECOMMENDED</span><strong>No close compatible stock size found</strong><p>We did not force a weak match. Your ${escapeHtml(formatDimension(result.requestedWidth))}\" × ${escapeHtml(formatDimension(result.requestedLength))}\" request is ready to send with your printer and shape.</p><a class="ffsf-button ffsf-button--primary" href="${escapeHtml(quoteUrl)}">Request My Exact Size</a></div>`;
      }

      const match = result.match;
      const maxWidth = Math.max(result.requestedWidth, match.candidateWidth);
      const maxLength = Math.max(result.requestedLength, match.candidateLength);
      const requestWidthPercent = Math.max(18, Math.round(result.requestedWidth / maxWidth * 100));
      const requestLengthPercent = Math.max(18, Math.round(result.requestedLength / maxLength * 100));
      const matchWidthPercent = Math.max(18, Math.round(match.candidateWidth / maxWidth * 100));
      const matchLengthPercent = Math.max(18, Math.round(match.candidateLength / maxLength * 100));
      const exact = match.absoluteWidthDifference < .001 && match.absoluteLengthDifference < .001;
      const hasSaleForSize = shapeLabels.some((label) => label.size === match.label.size && label.sale);
      const leavesSaleOnly = this.state.saleOnly && !hasSaleForSize;
      const differenceText = `${readableDimensionDifference(match.widthDifference, 'width')} · ${readableDimensionDifference(match.lengthDifference, 'length')}`;
      const shapeName = {
        rectangle: 'rectangle',
        square: 'square',
        circle: 'circle',
        continuous: 'continuous-roll'
      }[this.state.shape] || 'selected';
      return `<article class="ffsf-size-assist__match">
        <div class="ffsf-size-overlay" aria-label="Overlay comparing your requested dimensions with the closest stocked size">
          <span class="ffsf-size-overlay__stock" style="width:${matchWidthPercent}%;height:${matchLengthPercent}%"><i>Stock</i></span>
          <span class="ffsf-size-overlay__request" style="width:${requestWidthPercent}%;height:${requestLengthPercent}%"><i>Yours</i></span>
        </div>
        <div class="ffsf-size-assist__match-copy">
          <span class="ffsf-size-assist__status">${exact ? 'EXACT STOCKED MATCH' : 'CLOSEST COMPATIBLE STOCK SIZE'}</span>
          <h4>${escapeHtml(match.label.size)}</h4>
          <div class="ffsf-size-assist__chips">
            <span><small>Requested</small><strong>${escapeHtml(formatDimension(result.requestedWidth))}\" × ${escapeHtml(formatDimension(result.requestedLength))}\"</strong></span>
            <span><small>Recommended</small><strong>${escapeHtml(match.label.size)}</strong></span>
            <span><small>Difference</small><strong>${escapeHtml(differenceText)}</strong></span>
          </div>
          <p class="ffsf-size-assist__compatibility"><b aria-hidden="true">✓</b> Same ${escapeHtml(shapeName)} shape and verified for ${escapeHtml(this.printer ? this.printer.name : 'your printer')}.</p>
          ${leavesSaleOnly ? '<p class="ffsf-size-assist__pricing-note"><strong>Closest regular-price match:</strong> no close sale-only size qualified, so this choice will reopen all compatible materials.</p>' : ''}
          <div class="ffsf-size-assist__actions"><button type="button" class="ffsf-button ffsf-button--primary" data-action="select-size" data-size="${escapeHtml(match.label.size)}" data-assistant-match="true" data-assistant-regular="${leavesSaleOnly}">Use This Stock Size</button><a class="ffsf-button ffsf-button--secondary" href="${escapeHtml(quoteUrl)}">Request My Exact Size</a></div>
        </div>
      </article>`;
    }

    renderMaterials() {
      const printer = this.printer;
      if (!printer || !this.state.shape || !this.state.size) return this.setScreen('labels', false);
      const products = printerLabels(printer).filter((label) => (
        shapeKey(label) === this.state.shape
        && label.size === this.state.size
        && (!this.state.saleOnly || label.sale)
      ));
      const ordered = [...products].sort((a, b) => MATERIAL_ORDER.indexOf(a.material) - MATERIAL_ORDER.indexOf(b.material));
      const token = this.renderToken;
      this.app.innerHTML = `
        ${this.builderToolbar(printer, `${this.state.size} · Choose material`, 'back-labels')}
        ${this.labelProgress(2)}
        <div class="ffsf-builder-heading"><p class="ffsf-eyebrow">LABEL ROLL · STEP 2 OF 3</p><h2>Choose your label material</h2><p>Every option below is a real ${escapeHtml(this.state.size)} product that fits your selection. Sale pricing is shown automatically.</p></div>
        <div class="ffsf-selection-ribbon"><span>✓ ${escapeHtml(printer.model)}</span><span>✓ ${escapeHtml(this.state.size)}</span><span>✓ ${escapeHtml((printer.profiles || [printer.profile]).join(' + '))}</span></div>
        <div class="ffsf-material-grid">${ordered.map((product) => this.materialCard(product)).join('')}</div>
        ${!ordered.length ? '<div class="ffsf-empty"><strong>No exact material match found.</strong>Choose a different size or contact ForeFront.</div>' : ''}
      `;
      this.hydrateMaterials(ordered, token);
    }

    materialCard(product, live = null) {
      const variant = live ? findVariant(live, product.sku) : null;
      const price = variant ? variant.price : product.price;
      const compareAt = variant ? variant.compare_at_price : product.compareAt;
      const available = variant ? variant.available : true;
      const isSale = live ? Number(compareAt) > Number(price) : (product.sale || Number(compareAt) > Number(price));
      const image = live ? (variant && variant.featured_image && variant.featured_image.src) || live.featured_image || (live.images || [])[0] : product.image;
      return `<button type="button" class="ffsf-material-card" data-action="select-material" data-material="${escapeHtml(product.material)}" data-handle="${escapeHtml(product.handle)}" aria-label="Choose ${escapeHtml(product.materialName)} at ${escapeHtml(money(price))} per roll" ${available ? '' : 'disabled'}>
        ${isSale ? '<span class="ffsf-sale-badge">SALE</span>' : ''}
        <span class="ffsf-material-card__image"><img src="${escapeHtml(imageUrl(image, 480))}" width="480" height="420" loading="lazy" alt="${escapeHtml(product.title)}"></span>
        <span class="ffsf-material-card__copy">
          <span class="ffsf-kicker">${available ? 'AVAILABLE TO ORDER' : 'CURRENTLY UNAVAILABLE'}</span>
          <span class="ffsf-material-card__title">${escapeHtml(`${this.state.size} ${product.materialName}`)}</span>
          <span class="ffsf-material-card__description">${escapeHtml(MATERIAL_COPY[product.material] || 'Compatible ForeFront inkjet label material.')}</span>
          ${isSale ? '<span class="ffsf-material-card__offer ffsf-material-card__offer--sale">SALE PRICE APPLIED</span>' : '<span class="ffsf-material-card__offer">BULK PRICING AVAILABLE</span>'}
          <span class="ffsf-price"><strong>${money(price)}</strong>${Number(compareAt) > Number(price) ? `<del>${money(compareAt)}</del>` : ''}<span>per roll</span></span>
        </span>
      </button>`;
    }

    async hydrateMaterials(products, token) {
      await Promise.all(products.map(async (product) => {
        try {
          const live = await getLiveProduct(product.handle);
          if (token !== this.renderToken || this.state.screen !== 'materials') return;
          const card = this.app.querySelector(`[data-handle="${CSS.escape(product.handle)}"]`);
          if (card) card.outerHTML = this.materialCard(product, live);
        } catch (_error) {
          // Exported product data remains visible with a working product link at the next step.
        }
      }));
    }

    selectedLabel() {
      const printer = this.printer;
      const labels = printerLabels(printer);
      if (this.state.labelHandle) {
        const exact = labels.find((label) => label.handle === this.state.labelHandle);
        if (exact) return exact;
      }
      return labels.find((label) => shapeKey(label) === this.state.shape && label.size === this.state.size && label.material === this.state.material) || null;
    }

    renderOrder(live = null, tierConfig = null, productContext = null, hydrated = false) {
      const printer = this.printer;
      const product = this.selectedLabel();
      if (!printer || !product) return this.setScreen('materials', false);
      const variant = live ? findVariant(live, product.sku) : null;
      const price = variant ? variant.price : product.price;
      const compareAt = variant ? variant.compare_at_price : product.compareAt;
      const available = variant ? variant.available : true;
      const image = live ? (variant && variant.featured_image && variant.featured_image.src) || live.featured_image || (live.images || [])[0] : product.image;
      const isSale = live ? Number(compareAt) > Number(price) : (product.sale || Number(compareAt) > Number(price));
      const bulkConfig = !isSale && isDealEasyEligible(tierConfig, productContext) ? tierConfig : null;
      const rows = bulkConfig ? pricingRows(price, bulkConfig) : [];
      const activeRow = activePricingRow(rows, this.state.quantity);
      const unitPrice = activeRow ? activeRow.unitPrice : Number(price || 0);
      const total = unitPrice * this.state.quantity;
      const bulkSavings = Math.max(0, (Number(price || 0) - unitPrice) * this.state.quantity);
      const saleSavings = isSale ? Math.max(0, (Number(compareAt || 0) - Number(price || 0)) * this.state.quantity) : 0;
      const savings = bulkSavings || saleSavings;
      const nextTier = bulkConfig && bulkConfig.tiers.find((tier) => tier.quantity > this.state.quantity);
      const token = this.renderToken;
      this.orderContext = { basePrice: Number(price || 0), compareAt: Number(compareAt || 0), isSale, bulkConfig, rows };

      const discountLabel = (value) => bulkConfig && bulkConfig.type === 'FIXED_AMOUNT' ? `${money(value * 100)} off` : `${value}% off`;
      const tierRows = rows.map((row) => {
        const active = activeRow && activeRow.quantity === row.quantity;
        const range = row.maxQuantity ? `${row.quantity}–${row.maxQuantity}` : `${row.quantity}+`;
        return `<tr class="${active ? 'is-active' : ''}" data-ffsf-tier-row data-tier-min="${row.quantity}" ${active ? 'aria-current="true"' : ''}>
          <td>${range} rolls</td>
          <td>${row.value ? escapeHtml(discountLabel(row.value)) : 'Standard price'}</td>
          <td><strong>${moneyWithCurrency(row.unitPrice)}</strong></td>
        </tr>`;
      }).join('');
      const quickQuantityButtons = QUICK_QUANTITIES.map((quantity) => {
        const quantityRow = activePricingRow(rows, quantity);
        const value = quantityRow && quantityRow.value ? discountLabel(quantityRow.value) : (isSale ? 'Sale price' : 'Standard');
        return `<button type="button" class="ffsf-quantity-preset ${this.state.quantity === quantity ? 'is-active' : ''}" data-action="quantity-preset" data-quantity="${quantity}" aria-pressed="${this.state.quantity === quantity}"><strong>${quantity} roll${quantity === 1 ? '' : 's'}</strong><span>${escapeHtml(value)}</span></button>`;
      }).join('');
      const labelsPerRoll = /label/i.test(String(product.roll || '')) ? Number(String(product.roll).replace(/[^0-9]/g, '')) : 0;
      const totalLabels = labelsPerRoll ? labelsPerRoll * this.state.quantity : 0;
      const perLabel = totalLabels ? Math.max(0, total / totalLabels) : 0;
      const quantityFacts = totalLabels ? `${totalLabels.toLocaleString()} total labels · ${money(perLabel)} per label` : `${this.state.quantity} roll${this.state.quantity === 1 ? '' : 's'} · ${escapeHtml(product.roll)}`;
      const addLabelText = available ? `Add ${this.state.quantity} Roll${this.state.quantity === 1 ? '' : 's'} · ${moneyWithCurrency(total)}` : 'Currently Unavailable';

      let pricingMessage = 'Choose a quantity to see your automatic savings.';
      if (bulkConfig && nextTier) {
        const remaining = Math.max(1, nextTier.quantity - this.state.quantity);
        pricingMessage = `Add ${remaining} more roll${remaining === 1 ? '' : 's'} to unlock ${discountLabel(nextTier.value)}.`;
      } else if (bulkConfig && activeRow && activeRow.value) {
        pricingMessage = `Best available tier unlocked: ${discountLabel(activeRow.value)} per roll.`;
      }

      let pricingBlock;
      if (!hydrated) {
        pricingBlock = '<div class="ffsf-volume-note ffsf-volume-note--loading"><strong>Loading your live bulk prices…</strong><p>We are checking the current ForeFront discount rules.</p></div>';
      } else if (isSale) {
        pricingBlock = '<div class="ffsf-sale-callout"><strong>Sale price already applied</strong><p>This label is already discounted. Volume discounts do not stack with sale pricing.</p></div>';
      } else if (bulkConfig) {
        pricingBlock = `<div class="ffsf-tier-pricing">
          <div class="ffsf-tier-pricing__heading"><span><strong>Automatic bulk pricing</strong><small>Current ForeFront label discount</small></span><span class="ffsf-live-pill">LIVE</span></div>
          <div class="ffsf-tier-table-wrap"><table class="ffsf-tier-table"><caption>Price per roll by quantity</caption><thead><tr><th scope="col">Quantity</th><th scope="col">Savings</th><th scope="col">Price per roll</th></tr></thead><tbody>${tierRows}</tbody></table></div>
          <p class="ffsf-tier-message" data-ffsf-tier-message>${escapeHtml(pricingMessage)}</p>
        </div>`;
      } else {
        pricingBlock = '<div class="ffsf-volume-note"><strong>Bulk pricing is confirmed in cart</strong><p>The live discount table could not load here. Shopify cart and checkout will still apply any eligible automatic discount.</p></div>';
      }

      this.app.innerHTML = `
        ${this.builderToolbar(printer, 'Your exact label match', 'back-materials')}
        ${this.labelProgress(3)}
        <div class="ffsf-builder-heading"><p class="ffsf-eyebrow">LABEL ROLL · STEP 3 OF 3</p><h2>Choose your quantity</h2><p>Review the exact ForeFront roll, current Canadian price and available bulk discount before adding it to cart.</p></div>
        <div class="ffsf-order-grid">
          <article class="ffsf-product-card">
            ${isSale ? '<span class="ffsf-sale-badge">SALE</span>' : ''}
            <div class="ffsf-product-card__image"><img src="${escapeHtml(imageUrl(image, 700))}" width="700" height="620" loading="lazy" alt="${escapeHtml(product.title)}"></div>
            <div class="ffsf-product-card__copy"><span class="ffsf-kicker">SKU ${escapeHtml(product.sku)}</span><h3>${escapeHtml((live && live.title) || product.title)}</h3><div class="ffsf-price"><strong>${moneyWithCurrency(price)}</strong>${Number(compareAt) > Number(price) ? `<del>${moneyWithCurrency(compareAt)}</del>` : ''}<span>per roll</span></div><div class="ffsf-product-card__actions"><a class="ffsf-button ffsf-button--secondary" href="${escapeHtml(productUrl(product.handle))}">View Full Product Details</a></div></div>
          </article>
          <div class="ffsf-quantity-panel">
            ${pricingBlock}
            <div class="ffsf-quantity-presets" aria-label="Quick roll quantities">${quickQuantityButtons}</div>
            <div class="ffsf-quantity-row"><div><label for="ffsf-quantity-${escapeHtml(this.root.dataset.sectionId)}">Number of rolls</label><div class="ffsf-quantity-control"><button type="button" data-action="quantity-down" aria-label="Decrease quantity">−</button><input id="ffsf-quantity-${escapeHtml(this.root.dataset.sectionId)}" type="number" min="1" max="999" value="${this.state.quantity}" data-ffsf-quantity><button type="button" data-action="quantity-up" aria-label="Increase quantity">+</button></div></div><div class="ffsf-order-total" aria-live="polite"><span data-ffsf-unit-summary>${this.state.quantity} × ${moneyWithCurrency(unitPrice)} per roll</span><strong data-ffsf-order-total>${moneyWithCurrency(total)}</strong><small data-ffsf-savings>${savings ? `You save ${moneyWithCurrency(savings)}` : (isSale ? 'Sale price included' : (bulkConfig ? 'No bulk discount at this quantity' : 'Any eligible discount is confirmed in cart'))}</small></div></div>
            <p class="ffsf-quantity-facts" data-ffsf-quantity-facts data-labels-per-roll="${labelsPerRoll}">${quantityFacts}</p>
            <ul class="ffsf-spec-list"><li><strong>Printer</strong>${escapeHtml(printer.model)}</li><li><strong>Roll format</strong>${escapeHtml(product.profile)}</li><li><strong>Size</strong>${escapeHtml(product.size)}</li><li><strong>Material</strong>${escapeHtml(product.materialName)}</li><li><strong>Roll count</strong>${escapeHtml(product.roll)}</li><li><strong>Availability</strong>${available ? 'Available to order' : 'Currently unavailable'}</li></ul>
            <div class="ffsf-product-card__actions">${this.state.restockIntent ? `<button type="button" class="ffsf-button ffsf-button--primary" data-action="go-restock">Confirm Labels &amp; Choose Ink</button>` : `<button type="button" class="ffsf-button ffsf-button--primary" data-action="add-label" data-ffsf-add-label data-handle="${escapeHtml(product.handle)}" data-sku="${escapeHtml(product.sku)}" ${available ? '' : 'disabled'}>${addLabelText}</button>${this.restockInkProduct(printer) ? '<button type="button" class="ffsf-button ffsf-button--secondary" data-action="go-restock">Build a Labels + Ink Restock</button>' : ''}`}<a class="ffsf-product-link" href="${escapeHtml(productUrl(product.handle))}">View Full Product Details</a><small class="ffsf-cart-truth">Eligible DealEasy savings apply automatically in cart and checkout.</small></div>
          </div>
        </div>
        <div class="ffsf-mobile-order-bar"><span><small>${this.state.quantity} roll${this.state.quantity === 1 ? '' : 's'}</small><strong data-ffsf-mobile-total>${moneyWithCurrency(total)}</strong></span><button type="button" data-action="${this.state.restockIntent ? 'go-restock' : 'add-label'}" data-handle="${escapeHtml(product.handle)}" data-sku="${escapeHtml(product.sku)}" ${available ? '' : 'disabled'}>${this.state.restockIntent ? 'Choose Ink' : 'Add to Cart'}</button></div>
      `;
      if (!hydrated) {
        Promise.allSettled([
          getLiveProduct(product.handle),
          getDealEasyLabelConfig(),
          getDealEasyProductContext(product.handle)
        ]).then((results) => {
          if (token !== this.renderToken || this.state.screen !== 'order') return;
          const liveResult = results[0].status === 'fulfilled' ? results[0].value : null;
          const configResult = results[1].status === 'fulfilled' ? results[1].value : null;
          const productResult = results[2].status === 'fulfilled' ? results[2].value : null;
          this.renderOrder(liveResult, configResult, productResult, true);
          if (!liveResult) this.announce('The exported match is visible. Live availability will be checked again when you add it to cart.');
        });
      }
    }

    groupedInk(printer) {
      const groups = new Map();
      printerInk(printer).forEach((item) => {
        if (!groups.has(item.handle)) groups.set(item.handle, { ...item, variants: [] });
        groups.get(item.handle).variants.push({ sku: item.sku, option: item.option, price: item.price, compareAt: item.compareAt, sale: item.sale });
      });
      return [...groups.values()];
    }

    renderInk() {
      const printer = this.printer;
      if (!printer) return this.setScreen('printers', false);
      let products = this.groupedInk(printer);
      const categories = unique(products.map((product) => product.category));
      if (this.state.inkCategory !== 'all') products = products.filter((product) => product.category === this.state.inkCategory || (this.state.inkCategory === 'set' && /ink set\s*\+\s*maintenance box kit/i.test(product.title || '')));
      const token = this.renderToken;
      this.app.innerHTML = `
        ${this.builderToolbar(printer, 'Ink and maintenance supplies', 'back-supplies')}
        <div class="ffsf-builder-heading"><p class="ffsf-eyebrow">EXACT GENUINE SUPPLY MATCHES</p><h2>Ink &amp; maintenance for ${escapeHtml(printer.name)}</h2><p>Select the cartridge or kit you need. The live Shopify variant is verified again before cart addition.</p></div>
        <div class="ffsf-ink-tabs" aria-label="Filter ink products"><button type="button" class="ffsf-ink-tab ${this.state.inkCategory === 'all' ? 'is-active' : ''}" data-action="ink-category" data-category="all" aria-pressed="${this.state.inkCategory === 'all'}">All <span>(${this.groupedInk(printer).length})</span></button>${categories.map((category) => `<button type="button" class="ffsf-ink-tab ${this.state.inkCategory === category ? 'is-active' : ''}" data-action="ink-category" data-category="${escapeHtml(category)}" aria-pressed="${this.state.inkCategory === category}">${escapeHtml(this.categoryName(category))}</button>`).join('')}</div>
        <div class="ffsf-ink-grid">${products.map((product) => this.inkCard(product)).join('')}</div>
        ${!products.length ? '<div class="ffsf-empty"><strong>No products in this filter.</strong>Choose All to see every exact ink and maintenance match.</div>' : ''}
      `;
      this.hydrateInk(products, token);
    }

    categoryName(category) {
      const names = { cartridge: 'Cartridges', set: 'Multipacks', kit: 'Kits', maintenance: 'Maintenance', accessory: 'Accessories' };
      return names[category] || String(category || 'Other').replace(/(^|-)\w/g, (match) => match.replace('-', ' ').toUpperCase());
    }

    async updateInkImage(image, handle, sku) {
      if (!image) return;
      image.dataset.selectedSku = sku;
      try {
        const live = await getLiveProduct(handle);
        if (!image.isConnected || image.dataset.selectedSku !== sku) return;
        const variant = findVariant(live, sku);
        if (!variant) return;
        const media = variant.featured_image;
        const source = media || live.featured_image || (live.images || [])[0];
        if (!source) return;
        image.src = imageUrl(source, 480);
        image.alt = (media && media.alt) || `${live.title} - ${variant.title}`;
        image.hidden = false;
      } catch (_error) {}
    }

    inkCard(product, live = null) {
      const variants = product.variants || [];
      const first = variants[0] || product;
      const selectedSku = this.state.inkVariants[product.handle] || first.sku;
      const selected = variants.find((variant) => variant.sku === selectedSku) || first;
      const liveVariant = live ? findVariant(live, selected.sku) : null;
      const price = liveVariant ? liveVariant.price : selected.price;
      const compareAt = liveVariant ? liveVariant.compare_at_price : selected.compareAt;
      const available = live ? Boolean(liveVariant && liveVariant.available) : true;
      const selectedImage = liveVariant && liveVariant.featured_image;
      const image = live ? selectedImage || live.featured_image || (live.images || [])[0] : product.image;
      const imageAlt = (selectedImage && selectedImage.alt) || `${product.title}${selected.option ? ` - ${selected.option}` : ''}`;
      const completeKit = /ink set\s*\+\s*maintenance box kit/i.test(product.title || '');
      return `<article class="ffsf-ink-card" data-ink-card="${escapeHtml(product.handle)}">
        ${product.sale || Number(compareAt) > Number(price) ? '<span class="ffsf-sale-badge">SALE</span>' : ''}
        ${completeKit ? '<span class="ffsf-kit-badge">COMPLETE RESTOCK KIT</span>' : ''}
        <div class="ffsf-ink-card__image"><img src="${escapeHtml(imageUrl(image, 480))}" width="480" height="420" loading="lazy" alt="${escapeHtml(imageAlt)}" ${variants.length > 1 && !live ? 'hidden' : ''}></div>
        <div class="ffsf-ink-card__copy"><span class="ffsf-kicker">${escapeHtml(this.categoryName(product.category).toUpperCase())}</span><h3>${escapeHtml((live && live.title) || product.title)}</h3><div class="ffsf-price"><strong data-ink-price>${money(price)}</strong><del data-ink-compare ${Number(compareAt) > Number(price) ? '' : 'hidden'}>${Number(compareAt) > Number(price) ? money(compareAt) : ''}</del></div>
          ${variants.length > 1 ? `<label for="ink-${escapeHtml(product.handle)}">Choose black ink configuration</label><select id="ink-${escapeHtml(product.handle)}" data-ink-option data-handle="${escapeHtml(product.handle)}">${variants.map((variant) => { const matched = live ? findVariant(live, variant.sku) : null; const optionPrice = matched ? matched.price : variant.price; const optionCompare = matched ? matched.compare_at_price : variant.compareAt; const optionAvailable = matched ? matched.available : true; return `<option value="${escapeHtml(variant.sku)}" data-price="${Number(optionPrice || 0)}" data-compare-at="${Number(optionCompare || 0)}" data-available="${optionAvailable}" ${variant.sku === selected.sku ? 'selected' : ''}>${escapeHtml(variant.option || variant.sku)}</option>`; }).join('')}</select>` : ''}
          <div class="ffsf-ink-card__actions"><button type="button" class="ffsf-button ffsf-button--primary" data-action="add-ink" data-handle="${escapeHtml(product.handle)}" data-sku="${escapeHtml(selected.sku)}" ${available ? '' : 'disabled'}>${available ? 'Add to Cart' : 'Unavailable'}</button><a class="ffsf-product-link" href="${escapeHtml(productUrl(product.handle))}">View product</a></div>
        </div>
      </article>`;
    }

    async hydrateInk(products, token) {
      const queue = [...products];
      const worker = async () => {
        while (queue.length) {
          const product = queue.shift();
          try {
            const live = await getLiveProduct(product.handle);
            if (token !== this.renderToken || this.state.screen !== 'ink') return;
            const card = this.app.querySelector(`[data-ink-card="${CSS.escape(product.handle)}"]`);
            if (card) card.outerHTML = this.inkCard(product, live);
          } catch (_error) {
            // Keep the exported card and product link available.
          }
        }
      };
      await Promise.all(Array.from({ length: Math.min(4, queue.length) }, worker));
    }

    restockInkProduct(printer) {
      const products = this.groupedInk(printer);
      const restockProducts = products.filter((product) => (
        product.category === 'kit'
        || product.category === 'set'
        || /(?:ink|cartridge)\s+(?:multi-?pack|set)|maintenance\s+box\s+kit/i.test(product.title || '')
      ));
      return restockProducts.find((product) => product.handle === this.state.restockInkHandle)
        || restockProducts.find((product) => /ink set\s*\+\s*maintenance box kit/i.test(product.title || ''))
        || restockProducts.find((product) => product.category === 'kit')
        || restockProducts.find((product) => product.category === 'set')
        || null;
    }

    renderRestock() {
      const printer = this.printer;
      if (!printer) return this.setScreen('printers', false);
      const label = this.selectedLabel();
      const inkProduct = this.restockInkProduct(printer);
      if (!inkProduct) return this.setScreen('supplies', false);
      const variants = inkProduct.variants || [];
      const firstInk = variants[0] || inkProduct;
      const selectedInkSku = this.state.restockInkSku || firstInk.sku;
      const selectedInk = variants.find((variant) => variant.sku === selectedInkSku) || firstInk;
      const isCompleteKit = /ink set\s*\+\s*maintenance box kit/i.test(inkProduct.title || '') || inkProduct.category === 'kit';
      this.state.restockInkHandle = inkProduct.handle;
      this.state.restockInkSku = selectedInk.sku;
      this.replaceTrail();
      const labelTotal = label ? Number(label.price || 0) * this.state.quantity : 0;
      const inkTotal = Number(selectedInk.price || 0);
      const estimatedTotal = labelTotal + inkTotal;
      const inkOptions = variants.length > 1 ? `<label for="ffsf-restock-ink-${escapeHtml(this.root.dataset.sectionId)}">Choose black ink configuration</label><select id="ffsf-restock-ink-${escapeHtml(this.root.dataset.sectionId)}" data-restock-ink-option>${variants.map((variant) => `<option value="${escapeHtml(variant.sku)}" data-price="${Number(variant.price || 0)}" ${variant.sku === selectedInk.sku ? 'selected' : ''}>${escapeHtml(variant.option || variant.sku)}</option>`).join('')}</select>` : '';
      const labelCard = label ? `<article class="ffsf-restock-card"><span class="ffsf-restock-number">1</span><img src="${escapeHtml(imageUrl(label.image, 420))}" width="420" height="340" loading="lazy" alt="${escapeHtml(label.title)}"><div><span class="ffsf-kicker">COMPATIBLE LABELS SELECTED</span><h3>${escapeHtml(label.size)} ${escapeHtml(label.materialName)}</h3><p>${escapeHtml(label.roll)} per roll · Quantity ${this.state.quantity}</p><strong>${moneyWithCurrency(labelTotal)}</strong><button type="button" data-action="restock-choose-labels">Change label choice</button></div></article>`
        : `<article class="ffsf-restock-card is-needed"><span class="ffsf-restock-number">1</span><div><span class="ffsf-kicker">LABEL CHOICE REQUIRED</span><h3>Choose your compatible label rolls</h3><p>Select the shape, size and material before the labels and ink can be added safely.</p><button type="button" class="ffsf-button ffsf-button--primary" data-action="restock-choose-labels">Choose Compatible Labels</button></div></article>`;
      const inkCard = `<article class="ffsf-restock-card"><span class="ffsf-restock-number">2</span><img src="${escapeHtml(imageUrl(inkProduct.image, 420))}" width="420" height="340" loading="lazy" alt="${escapeHtml(inkProduct.title)}"><div><span class="ffsf-kicker">${isCompleteKit ? 'INK + MAINTENANCE KIT' : 'COMPATIBLE INK MULTIPACK'}</span><h3>${escapeHtml(inkProduct.title)}</h3>${inkOptions}<strong data-ffsf-restock-ink-price>${moneyWithCurrency(selectedInk.price)}</strong><a href="${escapeHtml(productUrl(inkProduct.handle))}">View product details</a></div></article>`;

      this.app.innerHTML = `
        ${this.builderToolbar(printer, 'Labels + ink restock', 'back-supplies')}
        <div class="ffsf-builder-heading"><p class="ffsf-eyebrow">LABELS + INK</p><h2>Restock your ${escapeHtml(printer.model)} in one review</h2><p>Every item is verified against the selected printer before anything is added to Shopify cart.</p></div>
        <div class="ffsf-restock-grid">${labelCard}${inkCard}</div>
        <aside class="ffsf-restock-summary"><div><small>ESTIMATED COMPONENT TOTAL</small><strong data-ffsf-restock-total>${moneyWithCurrency(estimatedTotal)}</strong><span>No unapproved bundle discount is included. Live prices and availability are checked again before cart.</span></div><button type="button" class="ffsf-button ffsf-button--primary" data-action="add-restock" ${label ? '' : 'disabled'}>Add Labels + Ink to Cart</button></aside>
      `;
      this.updateInkImage(this.app.querySelector('[data-restock-ink-option]')?.closest('article')?.querySelector('img'), inkProduct.handle, selectedInk.sku);
    }

    onInput(event) {
      if (event.target.matches('[data-ffsf-size-search]')) {
        const query = event.target.value.trim().toLowerCase();
        this.app.querySelectorAll('[data-size-text]').forEach((button) => {
          button.hidden = query && !button.dataset.sizeText.includes(query);
        });
        const dimensions = query.match(/[0-9.]+/g) || [];
        if (dimensions.length) {
          this.state.requestedWidth = dimensions[0] || '';
          this.state.requestedLength = dimensions[1] || '';
          this.updateLivePreview();
        }
      }
      if (event.target.matches('[data-ffsf-size-assist-input]')) {
        const key = event.target.dataset.dimension === 'length' ? 'requestedLength' : 'requestedWidth';
        this.state[key] = event.target.value;
        this.replaceTrail();
        this.updateLivePreview();
        const result = this.app.querySelector('[data-ffsf-size-assist-result]');
        if (result && this.printer && this.state.shape) {
          const shapeLabels = printerLabels(this.printer).filter((label) => shapeKey(label) === this.state.shape);
          result.innerHTML = this.renderSizeAssistResult(shapeLabels);
        }
      }
      if (event.target.matches('[data-ffsf-quantity]')) {
        this.state.quantity = Math.max(1, Math.min(999, Math.floor(Number(event.target.value) || 1)));
        this.replaceTrail();
        this.updateOrderTotal();
      }
    }

    updatePrinterSearch(value) {
      this.state.query = value;
      if (String(value || '').trim()) this.state.brand = 'all';
      this.replaceTrail();
      this.render();
      const input = this.app.querySelector('[data-ffsf-printer-search]');
      if (input) { input.focus(); input.setSelectionRange(input.value.length, input.value.length); }
    }

    updateLivePreview() {
      const preview = this.app.querySelector('[data-ffsf-live-preview]');
      if (!preview) return;
      const width = cleanDimension(this.state.requestedWidth);
      const length = cleanDimension(this.state.requestedLength);
      const isContinuous = this.state.shape === 'continuous';
      const text = this.state.size || (width ? `${formatDimension(width)}\" × ${length ? `${formatDimension(length)}\"` : '?'}` : 'Choose or type a size');
      const ratio = width && length ? Math.max(.55, Math.min(2, width / length)) : 1.35;
      const title = preview.querySelector('[data-live-preview-title]');
      const size = preview.querySelector('[data-live-preview-size]');
      const widthElement = preview.querySelector('[data-live-preview-width]');
      const lengthElement = preview.querySelector('[data-live-preview-length]');
      const swatch = preview.querySelector('[data-live-preview-swatch]');
      if (title) title.textContent = text;
      if (size) size.textContent = text;
      if (widthElement) widthElement.textContent = width ? `${formatDimension(width)}\"` : '-';
      if (lengthElement) lengthElement.textContent = isContinuous && width ? 'Continuous' : (length ? `${formatDimension(length)}\"` : '-');
      if (swatch) swatch.style.aspectRatio = `${ratio} / 1`;
    }

    onChange(event) {
      if (event.target.matches('[data-ink-option]')) {
        const card = event.target.closest('[data-ink-card]');
        const button = card && card.querySelector('[data-action="add-ink"]');
        const option = event.target.selectedOptions[0];
        const handle = event.target.dataset.handle;
        this.state.inkVariants = { ...this.state.inkVariants, [handle]: event.target.value };
        this.replaceTrail();
        this.updateInkImage(card && card.querySelector('.ffsf-ink-card__image img'), handle, event.target.value);
        if (button && option) {
          button.dataset.sku = event.target.value;
          button.disabled = option.dataset.available === 'false';
          button.textContent = button.disabled ? 'Unavailable' : 'Add to Cart';
        }
        const price = card && card.querySelector('[data-ink-price]');
        const compare = card && card.querySelector('[data-ink-compare]');
        if (price && option) price.textContent = money(Number(option.dataset.price || 0));
        if (compare && option) {
          const compareAt = Number(option.dataset.compareAt || 0);
          const currentPrice = Number(option.dataset.price || 0);
          compare.hidden = compareAt <= currentPrice;
          compare.textContent = compareAt > currentPrice ? money(compareAt) : '';
        }
      }
      if (event.target.matches('[data-restock-ink-option]')) {
        const option = event.target.selectedOptions[0];
        this.state.restockInkSku = event.target.value;
        this.replaceTrail();
        this.updateInkImage(event.target.closest('article')?.querySelector('img'), this.state.restockInkHandle, event.target.value);
        const inkPrice = Number(option && option.dataset.price || 0);
        const label = this.selectedLabel();
        const labelTotal = label ? Number(label.price || 0) * this.state.quantity : 0;
        const inkPriceElement = this.app.querySelector('[data-ffsf-restock-ink-price]');
        const totalElement = this.app.querySelector('[data-ffsf-restock-total]');
        if (inkPriceElement) inkPriceElement.textContent = moneyWithCurrency(inkPrice);
        if (totalElement) totalElement.textContent = moneyWithCurrency(labelTotal + inkPrice);
      }
    }

    onClick(event) {
      const target = event.target.closest('[data-action]');
      if (!target || !this.root.contains(target)) return;
      const action = target.dataset.action;
      if (action === 'jump-brand') {
        event.preventDefault();
        this.resetState();
        this.state.brand = target.dataset.brand || 'all';
        this.setScreen('printers');
        const tool = this.root.querySelector('.ffsf-tool-wrap');
        if (tool) tool.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
      if (action === 'history-back') { this.restoreTrail(this.trailIndex - 1); return; }
      if (action === 'history-forward') { this.restoreTrail(this.trailIndex + 1); return; }
      if (action === 'start-over') {
        this.resetState();
        const heroSearch = this.root.querySelector('[data-ffsf-hero-search]');
        if (heroSearch) heroSearch.value = '';
        this.trail = [this.snapshotState()];
        this.trailIndex = 0;
        this.updateUrl(false);
        this.render();
        this.announce('The finder has been reset. Choose your printer.');
        return;
      }
      if (action === 'hero-match' || action === 'deal-start') {
        const query = String((this.root.querySelector('[data-ffsf-hero-search]') || {}).value || '').trim();
        this.resetState();
        this.state.query = query;
        this.state.dealMode = action === 'deal-start';
        this.state.saleOnly = action === 'deal-start';
        this.track(action === 'deal-start' ? 'ffsf_deal_mode' : 'ffsf_hero_search', { search_used: Boolean(query) });
        this.setScreen('printers');
        return;
      }
      if (action === 'save-printer') {
        if (!this.printer) return;
        this.savedPrinterId = this.printer.id;
        try { window.localStorage.setItem(SAVED_PRINTER_KEY, this.savedPrinterId); } catch (_error) {}
        this.updateNavigation();
        this.announce(`${this.printer.name} saved for your next visit.`);
        return;
      }
      if (action === 'go-step') {
        const step = Number(target.dataset.step);
        if (step === 1) this.setScreen('printers');
        else if (step === 2 && this.printer) this.setScreen('supplies');
        else if (step === 3 && this.state.supply === 'ink') this.setScreen('ink');
        else if (step === 3 && this.state.supply === 'restock') this.setScreen('restock');
        else if (step === 3 && this.state.supply === 'labels') this.setScreen(this.state.material ? 'order' : (this.state.size ? 'materials' : 'labels'));
        return;
      }
      if (action === 'go-label-step') {
        const step = Number(target.dataset.labelStep);
        if (step === 1) this.setScreen('labels');
        else if (step === 2 && this.state.size) this.setScreen('materials');
        else if (step === 3 && this.state.material) this.setScreen('order');
        return;
      }
      if (action === 'clear-search') { this.state.query = ''; this.replaceTrail(); this.render(); return; }
      if (action === 'filter-brand') { this.state.brand = target.dataset.brand; this.replaceTrail(); this.render(); return; }
      if (action === 'select-core-profile') {
        this.state.printerId = target.dataset.profile;
        Object.assign(this.state, { supply: 'labels', shape: null, size: null, material: null, labelHandle: null, quantity: 1, restockIntent: false, requestedWidth: '', requestedLength: '' });
        this.track('ffsf_select_core_profile', { profile: this.printer && this.printer.profile });
        this.setScreen('labels');
        return;
      }
      if (action === 'switch-printer-group') { this.state.printerGroup = target.dataset.printerGroup === 'legacy' ? 'legacy' : 'current'; this.replaceTrail(); this.render(); return; }
      if (action === 'select-printer' || action === 'use-saved-printer') {
        const printerId = target.dataset.printer || this.savedPrinterId;
        const changed = this.state.printerId !== printerId;
        this.state.printerId = printerId;
        if (changed) Object.assign(this.state, { supply: null, shape: null, size: null, material: null, labelHandle: null, quantity: 1, inkCategory: 'all', inkVariants: {}, restockIntent: false, restockInkHandle: null, restockInkSku: null, requestedWidth: '', requestedLength: '' });
        const saleCount = this.printer ? printerLabels(this.printer).filter((label) => label.sale).length : 0;
        this.state.saleOnly = this.state.dealMode && saleCount > 0;
        this.track('ffsf_select_printer', { printer_id: this.state.printerId, printer_status: this.printer && this.printer.status, deal_mode: this.state.dealMode });
        this.announce(`${this.printer.name} selected. Choose labels or ink.`);
        this.setScreen('supplies');
        return;
      }
      if (action === 'pick-supply') {
        this.state.supply = target.dataset.supply;
        this.state.restockIntent = this.state.supply === 'restock';
        if (this.state.supply === 'labels' && this.state.dealMode) this.state.saleOnly = printerLabels(this.printer).some((label) => label.sale);
        this.track('ffsf_select_supply', { printer_id: this.state.printerId, supply_type: this.state.supply });
        this.setScreen(this.state.supply === 'ink' ? 'ink' : 'labels');
        return;
      }
      if (action === 'activate-deals') {
        this.state.dealMode = true;
        this.state.saleOnly = printerLabels(this.printer).some((label) => label.sale);
        this.track('ffsf_deal_mode', { printer_id: this.state.printerId, compatible_sale_count: printerLabels(this.printer).filter((label) => label.sale).length });
        this.setScreen('labels');
        return;
      }
      if (action === 'select-shape') {
        const shape = target.dataset.shape;
        if (shape === 'custom') {
          const requestUrl = this.root.dataset.customRequestUrl || '/pages/label-request';
          this.track('ffsf_custom_request_click', { printer_id: this.state.printerId });
          window.location.href = `${requestUrl}${requestUrl.includes('?') ? '&' : '?'}printer=${encodeURIComponent(this.printer.name)}&request=custom-label`;
          return;
        }
        if (this.state.shape !== shape) Object.assign(this.state, { shape, size: null, material: null, labelHandle: null, requestedWidth: '', requestedLength: '' });
        this.updateUrl(false);
        this.replaceTrail();
        this.render();
        return;
      }
      if (action === 'select-size') {
        if (target.dataset.assistantRegular === 'true') this.state.saleOnly = false;
        const selectedLabel = printerLabels(this.printer).find((label) => shapeKey(label) === this.state.shape && label.size === target.dataset.size);
        Object.assign(this.state, {
          size: target.dataset.size,
          material: this.state.size === target.dataset.size ? this.state.material : null,
          labelHandle: this.state.size === target.dataset.size ? this.state.labelHandle : null,
          requestedWidth: selectedLabel && selectedLabel.width != null ? String(selectedLabel.width) : '',
          requestedLength: selectedLabel && selectedLabel.length != null ? String(selectedLabel.length) : ''
        });
        this.setScreen('materials');
        return;
      }
      if (action === 'select-material') {
        this.state.material = target.dataset.material;
        this.state.labelHandle = target.dataset.handle;
        this.state.quantity = 1;
        this.track('ffsf_select_material', { printer_id: this.state.printerId, size: this.state.size, material: this.state.material, product_handle: this.state.labelHandle });
        this.setScreen('order');
        return;
      }
      if (action === 'toggle-sale') { this.state.saleOnly = !this.state.saleOnly; Object.assign(this.state, { shape: null, size: null, material: null, labelHandle: null, requestedWidth: '', requestedLength: '' }); this.replaceTrail(); this.render(); return; }
      if (action === 'ink-category') { this.state.inkCategory = target.dataset.category; this.replaceTrail(); this.render(); return; }
      if (action === 'quantity-preset') {
        this.state.quantity = Math.max(1, Math.min(999, Number(target.dataset.quantity) || 1));
        const input = this.app.querySelector('[data-ffsf-quantity]');
        if (input) input.value = this.state.quantity;
        this.replaceTrail();
        this.updateOrderTotal();
        return;
      }
      if (action === 'quantity-down' || action === 'quantity-up') {
        this.state.quantity = Math.max(1, Math.min(999, this.state.quantity + (action === 'quantity-up' ? 1 : -1)));
        const input = this.app.querySelector('[data-ffsf-quantity]');
        if (input) input.value = this.state.quantity;
        this.replaceTrail();
        this.updateOrderTotal();
        return;
      }
      if (action === 'add-label' || action === 'add-ink') {
        this.addToCart(target.dataset.handle, target.dataset.sku, action === 'add-label' ? this.state.quantity : 1, target);
        return;
      }
      if (action === 'go-restock') { this.state.supply = 'restock'; this.state.restockIntent = true; this.setScreen('restock'); return; }
      if (action === 'restock-choose-labels') { this.state.supply = 'labels'; this.state.restockIntent = true; this.setScreen('labels'); return; }
      if (action === 'add-restock') { this.addRestockToCart(target); return; }
      if (action === 'back-printers') { this.setScreen('printers'); return; }
      if (action === 'back-supplies') { this.setScreen('supplies'); return; }
      if (action === 'back-labels') { this.setScreen('labels'); return; }
      if (action === 'back-materials') { this.setScreen('materials'); }
    }

    updateOrderTotal() {
      const product = this.selectedLabel();
      if (!product) return;
      const context = this.orderContext || { basePrice: Number(product.price || 0), compareAt: Number(product.compareAt || 0), isSale: Boolean(product.sale), bulkConfig: null };
      const rows = context.bulkConfig ? pricingRows(context.basePrice, context.bulkConfig) : [];
      const activeRow = activePricingRow(rows, this.state.quantity);
      const unitPrice = activeRow ? activeRow.unitPrice : context.basePrice;
      const total = unitPrice * this.state.quantity;
      const bulkSavings = Math.max(0, (context.basePrice - unitPrice) * this.state.quantity);
      const saleSavings = context.isSale ? Math.max(0, (context.compareAt - context.basePrice) * this.state.quantity) : 0;
      const totalElement = this.app.querySelector('[data-ffsf-order-total]');
      const mobileTotal = this.app.querySelector('[data-ffsf-mobile-total]');
      const mobileQuantity = this.app.querySelector('.ffsf-mobile-order-bar small');
      const unitSummary = this.app.querySelector('[data-ffsf-unit-summary]');
      const savingsElement = this.app.querySelector('[data-ffsf-savings]');
      if (totalElement) totalElement.textContent = moneyWithCurrency(total);
      if (mobileTotal) mobileTotal.textContent = moneyWithCurrency(total);
      if (mobileQuantity) mobileQuantity.textContent = `${this.state.quantity} roll${this.state.quantity === 1 ? '' : 's'}`;
      if (unitSummary) unitSummary.textContent = `${this.state.quantity} × ${moneyWithCurrency(unitPrice)} per roll`;
      if (savingsElement) {
        if (bulkSavings) savingsElement.textContent = `You save ${moneyWithCurrency(bulkSavings)} with bulk pricing`;
        else if (saleSavings) savingsElement.textContent = `Sale savings ${moneyWithCurrency(saleSavings)}`;
        else savingsElement.textContent = context.isSale ? 'Sale price included' : (context.bulkConfig ? 'No bulk discount at this quantity' : 'Any eligible discount is confirmed in cart');
      }

      this.app.querySelectorAll('[data-ffsf-tier-row]').forEach((row) => {
        const active = Boolean(activeRow) && Number(row.dataset.tierMin) === activeRow.quantity;
        row.classList.toggle('is-active', active);
        if (active) row.setAttribute('aria-current', 'true');
        else row.removeAttribute('aria-current');
      });
      this.app.querySelectorAll('[data-action="quantity-preset"]').forEach((button) => {
        const active = Number(button.dataset.quantity) === this.state.quantity;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', String(active));
      });
      this.app.querySelectorAll('[data-ffsf-add-label]').forEach((button) => {
        button.textContent = `Add ${this.state.quantity} Roll${this.state.quantity === 1 ? '' : 's'} · ${moneyWithCurrency(total)}`;
      });
      const facts = this.app.querySelector('[data-ffsf-quantity-facts]');
      if (facts) {
        const labelsPerRoll = Number(facts.dataset.labelsPerRoll || 0);
        facts.textContent = labelsPerRoll
          ? `${(labelsPerRoll * this.state.quantity).toLocaleString()} total labels · ${money(total / (labelsPerRoll * this.state.quantity))} per label`
          : `${this.state.quantity} roll${this.state.quantity === 1 ? '' : 's'} · ${product.roll}`;
      }

      const message = this.app.querySelector('[data-ffsf-tier-message]');
      if (message && context.bulkConfig) {
        const nextTier = context.bulkConfig.tiers.find((tier) => tier.quantity > this.state.quantity);
        const label = (tier) => context.bulkConfig.type === 'FIXED_AMOUNT' ? `${money(tier.value * 100)} off` : `${tier.value}% off`;
        if (nextTier) {
          const remaining = nextTier.quantity - this.state.quantity;
          message.textContent = `Add ${remaining} more roll${remaining === 1 ? '' : 's'} to unlock ${label(nextTier)}.`;
        } else if (activeRow && activeRow.value) {
          message.textContent = `Best available tier unlocked: ${label(activeRow)} per roll.`;
        }
      }
      this.announce(`Quantity ${this.state.quantity}. Estimated total ${moneyWithCurrency(total)}.`);
    }

    async addToCart(handle, sku, quantity, button) {
      const original = button.textContent;
      button.disabled = true;
      button.textContent = 'Checking product…';
      try {
        const live = await getLiveProduct(handle);
        const variant = findVariant(live, sku);
        if (!variant) throw new Error('We could not safely match this product variant. Please open the product page.');
        if (!variant.available) throw new Error('This product is currently unavailable.');
        button.textContent = 'Adding…';
        const response = await fetch(this.root.dataset.cartAddUrl || `${rootPath()}cart/add.js`, {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: variant.id, quantity: Math.max(1, Number(quantity) || 1) }] })
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || 'Shopify could not add this item.');
        const cart = await this.refreshCartCount();
        document.dispatchEvent(new CustomEvent('cart-update', { bubbles: true, detail: { source: 'forefront-finder', cart: cart || result } }));
        const cartLine = cart && Array.isArray(cart.items) ? cart.items.find((item) => Number(item.variant_id) === Number(variant.id)) : null;
        const cartSavings = cartLine ? Math.max(0, Number(cartLine.original_line_price || 0) - Number(cartLine.final_line_price || 0)) : 0;
        this.track('ffsf_add_to_cart', { printer_id: this.state.printerId, product_handle: handle, sku, quantity: Math.max(1, Number(quantity) || 1), supply_type: this.state.supply });
        this.showToast(cartSavings ? `Added. Your cart now shows ${moneyWithCurrency(cartSavings)} in automatic savings.` : 'Added to your cart.', false);
        button.textContent = 'Added ✓';
        window.setTimeout(() => { button.disabled = false; button.textContent = original; }, 1800);
      } catch (error) {
        this.track('ffsf_cart_error', { printer_id: this.state.printerId, product_handle: handle, supply_type: this.state.supply });
        this.showToast(error.message || 'Could not add this item. Open the product page to continue.', true, productUrl(handle));
        button.disabled = false;
        button.textContent = original;
      }
    }

    async addRestockToCart(button) {
      const label = this.selectedLabel();
      const inkProduct = this.restockInkProduct(this.printer);
      if (!label || !inkProduct || !this.state.restockInkSku) return;
      const original = button.textContent;
      button.disabled = true;
      button.textContent = 'Checking every item…';
      try {
        const requested = [
          { handle: label.handle, sku: label.sku, quantity: Math.max(1, Number(this.state.quantity) || 1) },
          { handle: inkProduct.handle, sku: this.state.restockInkSku, quantity: 1 }
        ];
        const verified = await Promise.all(requested.map(async (item) => {
          const live = await getLiveProduct(item.handle);
          const variant = findVariant(live, item.sku);
          if (!variant) throw new Error(`We could not safely match ${item.sku}.`);
          if (!variant.available) throw new Error(`${live.title || item.sku} is currently unavailable.`);
          return { id: variant.id, quantity: item.quantity };
        }));
        button.textContent = 'Adding compatible items…';
        const response = await fetch(this.root.dataset.cartAddUrl || `${rootPath()}cart/add.js`, {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: verified })
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || 'Shopify could not add the restock items.');
        const cart = await this.refreshCartCount();
        document.dispatchEvent(new CustomEvent('cart-update', { bubbles: true, detail: { source: 'forefront-finder-restock', cart: cart || result } }));
        this.track('ffsf_add_restock', { printer_id: this.state.printerId, label_handle: label.handle, ink_handle: inkProduct.handle, label_quantity: this.state.quantity });
        this.showToast('Your compatible labels and ink were added to cart.', false);
        button.textContent = 'Restock added ✓';
        window.setTimeout(() => { button.disabled = false; button.textContent = original; }, 1800);
      } catch (error) {
        this.track('ffsf_cart_error', { printer_id: this.state.printerId, supply_type: 'restock' });
        this.showToast(error.message || 'Could not add the labels and ink together. Please try each item separately.', true);
        button.disabled = false;
        button.textContent = original;
      }
    }

    async refreshCartCount() {
      try {
        const response = await fetch(this.root.dataset.cartJsonUrl || `${rootPath()}cart.js`, { headers: { Accept: 'application/json' }, credentials: 'same-origin' });
        if (!response.ok) return null;
        const cart = await response.json();
        document.querySelectorAll('[data-cart-count]').forEach((element) => {
          element.textContent = cart.item_count;
          element.classList.toggle('is-empty', cart.item_count === 0);
        });
        return cart;
      } catch (_error) {
        // Cart succeeded, so a count-refresh failure must not show a false cart error.
        return null;
      }
    }

    showToast(message, error = false, fallbackUrl = '') {
      const oldToast = this.root.querySelector('.ffsf-toast');
      if (oldToast) oldToast.remove();
      const toast = document.createElement('div');
      toast.className = `ffsf-toast${error ? ' is-error' : ''}`;
      toast.setAttribute('role', error ? 'alert' : 'status');
      const link = error && fallbackUrl ? `<a href="${escapeHtml(fallbackUrl)}">Open product</a>` : `<a href="${escapeHtml(this.root.dataset.cartUrl || `${rootPath()}cart`)}">View cart</a>`;
      toast.innerHTML = `<strong>${escapeHtml(message)}</strong>${link}`;
      this.root.appendChild(toast);
      window.clearTimeout(this.toastTimer);
      this.toastTimer = window.setTimeout(() => toast.remove(), 6500);
    }
  }

  const boot = () => document.querySelectorAll('[data-ffsf-finder]').forEach((root) => {
    if (!root.dataset.ffsfReady) {
      root.dataset.ffsfReady = 'true';
      new ForeFrontFinder(root);
    }
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();


